import { configureStore } from "@reduxjs/toolkit/react";
import authReducer from "features/auth/authSlice";
import signUpreducer from "features/signUp/signUpSlice";
import resetPasswordReducer from "features/resetPassword/resetPasswordSlice";
import usersReducer from "pages/users/usersSlice";
import timeManagementReducer from "pages/timeManagement/timeManagementSlice";
import ordersReducer from "pages/orders/ordersSlice";
import viewOrderReducer from "pages/order/orderSlice";
import statisticsReducer from "pages/dashboard/statisticsSlice";
import baseApi from "./api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    signUp: signUpreducer,
    resetPassword: resetPasswordReducer,
    users: usersReducer,
    timeManagement: timeManagementReducer,
    orders: ordersReducer,
    order: viewOrderReducer,
    statistics: statisticsReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
  // Enable Redux devtools in development only
  devTools: process.env.NODE_ENV !== "production",
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
